import progress from "./index.vue";
export default progress;
